import { jsx as _jsx } from "react/jsx-runtime";
import { PlaceTypeKeyEnum } from '@aviv_price-pages/brand';
import BlockPage from './BlockPage';
import BoroughPage from './BoroughPage';
import BuildingPage from './BuildingPage';
import CountryPage from './CountryPage';
import CountyPage from './CountyPage';
import HouseNumberPage from './HouseNumberPage';
import MacroNeighborhoodPage from './MacroNeighborhoodPage';
import MacroRegionPage from './MacroRegionPage';
import MicroNeighborhoodPage from './MicroNeighborhoodPage';
import MicroRegionPage from './MicroRegionPage';
import MicroStatisticalUnitPage from './MicroStatisticalUnitPage';
import MunicipalityPage from './MunicipalityPage';
import NeighborhoodPage from './NeighborhoodPage';
import ParcelPage from './ParcelPage';
import ProvincePage from './ProvincePage';
import RegionPage from './RegionPage';
import StatisticalUnitPage from './StatisticalUnitPage';
import StreetPage from './StreetPage';
export const PageDispatcher = ({ place }) => {
    const geoPages = {
        [PlaceTypeKeyEnum.MUNICIPALITY]: _jsx(MunicipalityPage, {}),
        [PlaceTypeKeyEnum.REGION]: _jsx(RegionPage, {}),
        [PlaceTypeKeyEnum.PROVINCE]: _jsx(ProvincePage, {}),
        [PlaceTypeKeyEnum.BOROUGH]: _jsx(BoroughPage, {}),
        [PlaceTypeKeyEnum.STATISTICAL_UNIT]: _jsx(StatisticalUnitPage, {}),
        [PlaceTypeKeyEnum.NEIGHBORHOOD]: _jsx(NeighborhoodPage, {}),
        [PlaceTypeKeyEnum.MICRO_STAT_UNIT]: _jsx(MicroStatisticalUnitPage, {}),
        [PlaceTypeKeyEnum.STREET]: _jsx(StreetPage, {}),
        [PlaceTypeKeyEnum.BLOCK]: _jsx(BlockPage, {}),
        [PlaceTypeKeyEnum.PARCEL]: _jsx(ParcelPage, {}),
        [PlaceTypeKeyEnum.BUILDING]: _jsx(BuildingPage, {}),
        [PlaceTypeKeyEnum.HOUSE_NUMBER]: _jsx(HouseNumberPage, {}),
        [PlaceTypeKeyEnum.COUNTY]: _jsx(CountyPage, {}),
        [PlaceTypeKeyEnum.MACROREGION]: _jsx(MacroRegionPage, {}),
        [PlaceTypeKeyEnum.MACRO_NEIGHBORHOOD]: _jsx(MacroNeighborhoodPage, {}),
        [PlaceTypeKeyEnum.MICRO_NEIGHBORHOOD]: _jsx(MicroNeighborhoodPage, {}),
        [PlaceTypeKeyEnum.MICROREGION]: _jsx(MicroRegionPage, {}),
        [PlaceTypeKeyEnum.COUNTRY]: _jsx(CountryPage, {}),
    };
    return geoPages[place.typeKey];
};
